import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { Pagination } from 'interfaces/api.interfaces'
import { Group } from 'interfaces/api/groups.interfaces'
import {
  CreateGroupParams,
  GetGroupPermissionsParams,
  RemoveGroupParams,
  UpdateGroupParams,
  UpdateGroupPermissionsParams,
} from 'interfaces/store/groups.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllGroups = createAsyncThunk(
  'users/getAllGroups',
  async (pagination: Pagination | undefined, { rejectWithValue }) =>
    api.groups.getAll(pagination).catch((error) => rejectWithValue(error.message)),
)

export const getGroup = createAsyncThunk('users/getGroup', async (id: number, { rejectWithValue }) =>
  api.groups.getSingle(id).catch((error) => rejectWithValue(error.message)),
)

export const setSingleGroup = createAction<null | Group>('users/setSingleGroup')
export const setGroupValidationErrors = createAction<ValidationErrorsApi | null>('users/setGroupValidationErrors')

export const createGroup = createAsyncThunk(
  'users/createGroup',
  async (params: CreateGroupParams, { rejectWithValue, dispatch }) =>
    api.groups
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setGroupValidationErrors(null))
        toast.success(Success.GroupCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateGroup = createAsyncThunk(
  'users/updateGroup',
  async (params: UpdateGroupParams, { rejectWithValue, dispatch }) =>
    api.groups
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setGroupValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeGroup = createAsyncThunk(
  'users/removeGroup',
  async (params: RemoveGroupParams, { rejectWithValue }) =>
    api.groups
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.GroupRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const getAllPermissions = createAsyncThunk(
  'users/getAllPermissions',
  async (params: Pagination | undefined, { rejectWithValue }) =>
    api.groups.getAllPermissions(params).catch((error) => rejectWithValue(error.message)),
)

export const getGroupPermissions = createAsyncThunk(
  'users/getGroupPermissions',
  async (params: GetGroupPermissionsParams, { rejectWithValue }) =>
    api.groups
      .getGroupPermissions(params.groupId, {
        page: params.pagination?.page ?? 1,
        perPage: params.pagination?.perPage ?? 10000,
      })
      .then((data) => data.results.map((item) => item.id))
      .catch((error) => rejectWithValue(error.message)),
)

export const updateGroupPermissions = createAsyncThunk(
  'users/updateGroupPermissions',
  async (params: UpdateGroupPermissionsParams, { rejectWithValue }) =>
    api.groups.updateGroupPermissions(params.groupId, params.data).catch((error) => rejectWithValue(error.message)),
)
